var map = {
	"./A Guide to Capital Gains Tax (CGT).pdf": 67888,
	"./A Guide to Deducting Business Expenses for Self-Employed Individuals.pdf": 94822,
	"./A Guide to Renting Out Property as a Resident Landlord.pdf": 74772,
	"./Adding Pension Contributions to Your Tax Return.pdf": 60012,
	"./Bank interest – what needs to be calculated.pdf": 46441,
	"./Blind persons allowance.pdf": 23122,
	"./Bonuses on investments.pdf": 18253,
	"./Capital Allowances in the UK for Businesses.pdf": 89264,
	"./Capital Allowances.pdf": 91172,
	"./Cash Basis vs Traditional Accounting.pdf": 70396,
	"./Cash Gifts and Tax in the UK.pdf": 80633,
	"./Charitable giving in the UK.pdf": 87037,
	"./Claiming Tax Relief for Job Expenses in the UK.pdf": 5711,
	"./Claiming tax relief if employed.pdf": 39199,
	"./Declaring Student Loans on Your Self-Assessment Tax Return.pdf": 19873,
	"./Demystifying Dividends – A Guide to Shareholder Earnings.pdf": 71692,
	"./Demystifying the UTR Number  Your Key to Self Assessment.pdf": 54315,
	"./Do I need to keep receipts.pdf": 95639,
	"./Furnished Holiday Lettings (FHLs).pdf": 10096,
	"./Gains from  life insurance.pdf": 91839,
	"./ISA.pdf": 12443,
	"./Joint Ownership of Rental Property Taxation and Options.pdf": 2828,
	"./Marriage Allowance in the UK.pdf": 2671,
	"./Navigating Furnished Holiday Lettings (FHLs).pdf": 76251,
	"./Navigating Tax Reporting for Gilt-Edged and Other UK Securities.pdf": 41617,
	"./Navigating the High Income Child Benefit Charge in the UK.pdf": 2531,
	"./Navigating the Tax Maze Furnished Holiday Lets vs Residential Lets.pdf": 1380,
	"./Pensions, Annuities, and Benefits on Your Tax Return.pdf": 98424,
	"./Private Ownership of Property vs Limited Company.pdf": 5778,
	"./Rental Income and Taxation for UK Property Owners.pdf": 85901,
	"./Renting Out Property and Tax Considerations.pdf": 36841,
	"./Reporting covid grants and payments.pdf": 71555,
	"./Reporting of Trust Income on a UK Self-Assessment Tax Return.pdf": 69246,
	"./Self-Assessment for Foreigners in the UK – Reporting Foreign Income.pdf": 33170,
	"./Small Business Tax Tips – What Records to Keep and Why.pdf": 50163,
	"./Understanding Flat Rates for Self-Employed Individuals in the UK.pdf": 41067,
	"./Understanding Married Couple_s Allowance in the UK.pdf": 34189,
	"./Understanding Taxes on Stocks Dividends and Bonuses in the UK.pdf": 90814,
	"./Understanding Unique Tax Reference (UTR).pdf": 63807,
	"./Understanding What Expenses Can_t Be Claimed on Your Tax Return.pdf": 84617,
	"./Understanding your tax bill.pdf": 56368,
	"./Vehicle Use and Allowances for Businesses.pdf": 55475,
	"./What Information Do I Need to Complete My Tax Return.pdf": 58430,
	"./why do I need to include my employment on my self assessment.pdf": 79046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64838;